import { Inject, Injectable, Optional } from '@angular/core';
import { take } from 'rxjs';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { WebAngularSharedUtilOktaFeatureFlagUserContext } from '@content-platform/web-angular-shared-util-okta-feature-flag-user-context';
import * as i0 from "@angular/core";
import * as i1 from "@content-platform/web-angular-shared-util-logging";
/**
 * Runs one-shot {@link FeatureFlagUserResolver.resolveLaunchDarklyContext} for feature-flag client bootstrap.
 * Injected where async user context is required before creating the client (e.g. feature flags service).
 */
export class FeatureFlagUserContextInitService {
    constructor(rootLogger, userResolver) {
        this.userResolver = userResolver;
        this.logger = rootLogger.instance('FeatureFlagUserContextInitService');
    }
    subscribeOnce(handlers) {
        if (!this.userResolver) {
            handlers.onMissingOrError();
            return;
        }
        this.userResolver.resolveLaunchDarklyContext().pipe(take(1)).subscribe({
            next: (context) => {
                if (context) {
                    handlers.onContext(context);
                }
                else {
                    this.logger.error('Cannot initialize feature flags: user resolver returned no valid context');
                    handlers.onMissingOrError();
                }
            },
            error: (err) => {
                this.logger.error('Feature flag user context resolution failed: ', err);
                handlers.onMissingOrError();
            }
        });
    }
    static { this.ɵfac = function FeatureFlagUserContextInitService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FeatureFlagUserContextInitService)(i0.ɵɵinject(i1.LoggerService), i0.ɵɵinject(WebAngularSharedUtilOktaFeatureFlagUserContext, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FeatureFlagUserContextInitService, factory: FeatureFlagUserContextInitService.ɵfac, providedIn: 'root' }); }
}
//# sourceMappingURL=feature-flag-user-context-init.service.js.map